import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../cn';

export interface PillProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

/** Selectable preset pill (mobile presets strip): 34 px, 14 px padding, radius 17, 500 12px. */
export function Pill({ selected, className, children, ...rest }: PillProps) {
  return (
    <button
      type="button"
      aria-pressed={!!selected}
      className={cn(
        'h-[34px] flex-none whitespace-nowrap rounded-[17px] border px-3.5 text-base font-medium',
        selected ? 'border-transparent bg-fg text-bg' : 'border-border bg-transparent text-fg2 hover:text-fg',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
